import { USER_ROLES } from 'admin/users/userUtils';
import { DateField, SelectField, Show, SimpleShowLayout, TextField } from 'react-admin';

import { USER_INVITATION_STATUS_CHOICES } from './userInvitationUtils';

export const UserInvitationShow: React.FC = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField label="E-mail" source="email" />
      <SelectField choices={USER_ROLES} label="Rola" source="role" />
      <SelectField choices={USER_INVITATION_STATUS_CHOICES} label="Status" source="status" />
      <DateField label="Dátum ekspirácie" locales="sk" showTime={true} source="expirationTimestamp" />
      <DateField label="Dátum vytvorenia" locales="sk" showTime={true} source="creationTimestamp" />
      <DateField label="Dátum zmeny" locales="sk" showTime={true} source="updateTimestamp" />
    </SimpleShowLayout>
  </Show>
);
